// components/SummaryPage.jsx

const SummaryPage = ({ watch, accountTypes, domains, isParticulier, isEntrepriseType,nonManagedAccounts = [] // AJOUT: pour afficher les noms des mandataires
 }) => {
  const formData = watch();
  const selectedAccountType = accountTypes.find(at => at.id === formData.typeId);
  const selectedDomain = domains.find(d => d.id === formData.domainId);

  // Fonction pour obtenir le nom d'un mandataire
  const getRepresentativeName = (accountId) => {
    if (!accountId || !nonManagedAccounts.length) return 'Non spécifié';
    const account = nonManagedAccounts.find(acc => acc.value === accountId);
    return account ? account.label : `Compte ID: ${accountId}`;
  };

  const formatValue = (value) => {
    if (value === undefined || value === null || value === '') return 'Non renseigné';
    if (typeof value === 'boolean') return value ? 'Oui' : 'Non';
    if (value instanceof FileList && value.length > 0) return `Fichier: ${value[0].name}`;
    return value.toString();
  };

  const shouldShowField = (fieldName) => {
    if (isParticulier) {
      const particulierFields = [
        'firstName', 'lastName', 'email', 'phoneNumber', 'dob', 'countryOfBirth', 
        'cityOfBirth', 'address', 'job', 'description', 'preference',
        'numeroIdentificationFiscale','tva','convention_ouverture','kyc','formulaire_ouverture',
      ];
      return particulierFields.includes(fieldName);
    }
    
    if (isEntrepriseType) {
      const entrepriseFields = [
        'companyName', 'company_adress', 'email', 'phoneNumber', 'legalForm', 
        'capital', 'yearlyRevenue', 'cash', 'totalOutstandingShares', 'isin','tva','convention_ouverture','kyc','formulaire_ouverture',
        'numeroCompteBancaire', 'numeroIdentificationFiscale', 'description', 'preference'
      ];
      return entrepriseFields.includes(fieldName);
    }
    
    return true;
  };

  const getFieldLabel = (fieldName) => {
    const labels = {
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'Email',
      phoneNumber: 'Téléphone',
      dob: 'Date de naissance',
      countryOfBirth: 'Pays de naissance',
      cityOfBirth: 'Ville de naissance',
      address: 'Adresse',
      job: 'Profession',
      description: 'Description',
      preference: 'Préférence d\'investissement',
      companyName: 'Nom de l\'entreprise',
      company_adress: 'Adresse de l\'entreprise',
      legalForm: 'Forme juridique',
      capital: 'Capital',
      yearlyRevenue: 'Revenu annuel',
      cash: 'Cash',
      totalOutstandingShares: 'Total Outstanding Shares',
      isin: 'ISIN',
      tva: 'Tva',
      numeroCompteBancaire: 'Numéro de compte bancaire',
      numeroIdentificationFiscale: 'Numéro d\'identification fiscale (NIU)'
    };
    
    return labels[fieldName] || fieldName;
  };

  return (
    <div className="page-content">
      <div className="page-header mb-4">
        <h2 className="h4 mb-2">Récapitulatif</h2>
        <p className="text-muted">
          Vérifiez toutes les informations avant de finaliser la création du compte.
        </p>
      </div>

      {/* <div className="row"> */}
        <div className="col-12">
          {/* Informations Générales */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="mb-0">Informations Générales</h5>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <dl className="row">
                    <dt className="col-sm-5">Domaine:</dt>
                    <dd className="col-sm-7">{selectedDomain?.name || 'Non sélectionné'}</dd>

                    <dt className="col-sm-5">Type de compte:</dt>
                    <dd className="col-sm-7">{selectedAccountType?.name || 'Non sélectionné'}</dd>

                    <dt className="col-sm-5">Email:</dt>
                    <dd className="col-sm-7">{formatValue(formData.email)}</dd>

                    <dt className="col-sm-5">Téléphone:</dt>
                    <dd className="col-sm-7">{formatValue(formData.phoneNumber)}</dd>
                  </dl>
                </div>
                <div className="col-md-6">
                  <dl className="row">
                    <dt className="col-sm-5">Description:</dt>
                    <dd className="col-sm-7">{formatValue(formData.description)}</dd>

                    <dt className="col-sm-5">Préférence d'investissement:</dt>
                    <dd className="col-sm-7">{formatValue(formData.preference)}</dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>

          {/* Informations Personnelles ou Entreprise */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="mb-0">
                {isParticulier ? 'Informations Personnelles' : 'Informations Entreprise'}
              </h5>
            </div>
            <div className="card-body">
              <div className="row">
                {Object.keys(formData)
                  .filter(fieldName => fieldName !== 'domainId' && fieldName !== 'typeId' && 
                          fieldName !== 'email' && fieldName !== 'phoneNumber' && 
                          fieldName !== 'description' && fieldName !== 'preference' &&
                          shouldShowField(fieldName))
                  .map((fieldName) => (
                    <div key={fieldName} className="col-md-6 mb-2">
                      <dt className="fw-medium">{getFieldLabel(fieldName)}:</dt>
                      <dd>{formatValue(formData[fieldName])}</dd>
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {/* Explication Total Outstanding Shares si présent */}
          {formData.totalOutstandingShares && formData.totalOutstandingShares > 0 && (
            <div className="alert alert-info">
              <h6 className="alert-heading">
                <i className="fas fa-info-circle me-2"></i>
                À propos du Total Outstanding Shares
              </h6>
              <p className="mb-0 small">
                Le <strong>Total Outstanding Shares</strong> ({formData.totalOutstandingShares}) représente le nombre total 
                d'actions actuellement en circulation et détenues par tous les actionnaires de l'entreprise.
              </p>
            </div>
          )}

          {/* Section pour les mandataires (si compte administré) */}
          {formData.IsManagedAccount && (
            <div className="card mb-4 border-primary">
              <div className="card-header bg-primary text-white">
                <h5 className="mb-0">
                  <i className="fas fa-user-shield me-2"></i>
                  Informations des Représentants Légaux
                </h5>
              </div>
              <div className="card-body">
                {formData.RepresentativeAccountIds && formData.RepresentativeAccountIds.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-sm">
                      <thead>
                        <tr>
                          {/* <th>#</th> */}
                          <th>Compte Mandataire</th>
                          <th>Type de Mandat</th>
                          <th>Relation</th>
                          <th>Preuve de Mandat</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData.RepresentativeAccountIds.map((accountId, index) => (
                          <tr key={index}>
                            {/* <td>{index + 1}</td> */}
                            <td>{getRepresentativeName(accountId)}</td>
                            <td>
                              {formData.MandateTypes && formData.MandateTypes[index] 
                                ? formData.MandateTypes[index] 
                                : 'Non spécifié'}
                            </td>
                            <td>
                              {formData.RelationshipTypes && formData.RelationshipTypes[index] 
                                ? formData.RelationshipTypes[index] 
                                : 'Non spécifié'}
                            </td>
                            <td>
                              {formData.MandateProofFiles && formData.MandateProofFiles[index] 
                                ? `Fichier: ${formData.MandateProofFiles[index].name}` 
                                : 'Aucun fichier'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="alert alert-warning">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    Aucun mandataire n'a été spécifié.
                  </div>
                )}
                
                {/* Information sur les documents non requis pour les mineurs */}
                {(() => {
                  const dob = formData.dob;
                  if (dob) {
                    const birthDate = new Date(dob);
                    const today = new Date();
                    let age = today.getFullYear() - birthDate.getFullYear();
                    const m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                      age--;
                    }
                    
                    if (age < 18) {
                      return (
                        <div className="alert alert-info mt-3">
                          <i className="fas fa-info-circle me-2"></i>
                          <strong>Note pour le mineur:</strong> Pour les personnes de moins de 18 ans avec 
                          représentant légal, les documents suivants ne sont pas obligatoires:
                          <ul className="mb-0 mt-2">
                            <li>CNI</li>
                            <li>Justificatif de domicile</li>
                            <li>Numéro d'Identification Fiscale (NIU)</li>
                          </ul>
                        </div>
                      );
                    }
                  }
                  return null;
                })()}
              </div>
            </div>
          )}
      

          {/* Explication ISIN si présent */}
          {formData.isin && (
            <div className="alert alert-warning">
              <h6 className="alert-heading">
                <i className="fas fa-exclamation-triangle me-2"></i>
                Information ISIN
              </h6>
              <p className="mb-0 small">
                L'ISIN <strong>{formData.isin}</strong> identifie de manière unique les titres financiers de votre entreprise 
                sur les marchés internationaux.
              </p>
            </div>
          )}

          <div className="alert alert-success">
            <i className="fas fa-check-circle me-2"></i>
            <strong>Vérification terminée.</strong> Si toutes les informations sont correctes, 
            vous pouvez soumettre le formulaire pour créer le compte.
          </div>
        </div>
      </div>
    // </div>
  );
};

export default SummaryPage;